// Sportage carousel images
import sportageFrontDesktop from "../../../assets/img/models/sportage/carousel/sportage-front-desktop.webp";
import sportageFrontMobile from "../../../assets/img/models/sportage/carousel/sportage-front-mobile.webp";
import sportageBackDesktop from "../../../assets/img/models/sportage/carousel/sportage-back-desktop.webp";
import sportageBackMobile from "../../../assets/img/models/sportage/carousel/sportage-back-mobile.webp";
import sportageSideDesktop from "../../../assets/img/models/sportage/carousel/sportage-side-desktop.webp";
import sportageSideMobile from "../../../assets/img/models/sportage/carousel/sportage-side-mobile.webp";
// Sportage hero video images
//import sportageHeroVideoDesktop from "../../../assets/videos/sportage-hero-desktop.mp4";
import sportageHeroVideoDesktop from "../../../assets/videos/sportage-hero-desktop.webp";
import sportageHeroVideoMobile from "../../../assets/videos/sportage-hero-mobile.webp";
// Sportage exterior images
import sportageExteriorBacklights from "../../../assets/img/models/sportage/exterior/sportage-exterior-backlights.webp";
import sportageExteriorGrille from "../../../assets/img/models/sportage/exterior/sportage-exterior-grille.webp";
import sportageExteriorLights from "../../../assets/img/models/sportage/exterior/sportage-exterior-lights.webp";
import sportageExteriorRooftop from "../../../assets/img/models/sportage/exterior/sportage-exterior-rooftop.webp";
import sportageExteriorWheel from "../../../assets/img/models/sportage/exterior/sportage-exterior-wheel.webp";
// Sportage interior images
import sportageInteriorGearbox from "../../../assets/img/models/sportage/interior/sportage-interior-gearbox.webp";
import sportageInteriorPanel from "../../../assets/img/models/sportage/interior/sportage-interior-panel.webp";
import sportageInteriorRooftop from "../../../assets/img/models/sportage/interior/sportage-interior-rooftop.webp";
import sportageInteriorSteeringWheel from "../../../assets/img/models/sportage/interior/sportage-interior-steering-wheel.webp";
import sportageInteriorTrunk from "../../../assets/img/models/sportage/interior/sportage-interior-trunk.webp";
// Sportage Atributes
import sportageAtributesDesktop from "../../../assets/img/models/sportage/atributes/sportage-atributes-desktop-nueva.webp";
import sportageAtributesMobile from "../../../assets/img/models/sportage/atributes/sportage-atributes-desktop-nueva.webp";
// Sportage Etiqueta
import sportageEtiqueta from "../../../assets/etiquetas/Etiqueta Sportage EX.pdf";
// Sportage Fichas
import sportageFichas from "../../../assets/fichas/Ficha técnica Sportage EX.pdf";

export const sportageImages = {
  carousel: {
    front: {
      desktop: sportageFrontDesktop,
      mobile: sportageFrontMobile,
    },
    back: {
      desktop: sportageBackDesktop,
      mobile: sportageBackMobile,
    },
    side: {
      desktop: sportageSideDesktop,
      mobile: sportageSideMobile,
    },
  },
  exterior: {
    backlights: {
      desktop: sportageExteriorBacklights,
      mobile: sportageExteriorBacklights,
    },
    grille: {
      desktop: sportageExteriorGrille,
      mobile: sportageExteriorGrille,
    },
    lights: {
      desktop: sportageExteriorLights,
      mobile: sportageExteriorLights,
    },
    rooftop: {
      desktop: sportageExteriorRooftop,
      mobile: sportageExteriorRooftop,
    },
    wheel: {
      desktop: sportageExteriorWheel,
      mobile: sportageExteriorWheel,
    },
  },
  interior: {
    steeringWheel: {
      desktop: sportageInteriorSteeringWheel,
      mobile: sportageInteriorSteeringWheel,
    },
    trunk: {
      desktop: sportageInteriorTrunk,
      mobile: sportageInteriorTrunk,
    },
    panel: {
      desktop: sportageInteriorPanel,
      mobile: sportageInteriorPanel,
    },
    gearbox: {
      desktop: sportageInteriorGearbox,
      mobile: sportageInteriorGearbox,
    },
    rooftop: {
      desktop: sportageInteriorRooftop,
      mobile: sportageInteriorRooftop,
    },
  },
  attributes: {
    desktop: sportageAtributesDesktop,
    mobile: sportageAtributesMobile,
  },
  heroVideo: {
    desktop: sportageHeroVideoDesktop,
    mobile: sportageHeroVideoMobile,
  },
  etiqueta: sportageEtiqueta,
  fichas: sportageFichas,
};
